import React, {useContext} from 'react';
import * as PropTypes from 'prop-types';
import {buyNowContext} from "../BuyNow";

const ProductPreview = ({ product, className }) => {
  if (product)
    return (
      <img
        className={`img-fluid position-sticky pt-3 w-100 mw-100 col-lg-10 px-3 ${className}`}
        src={product.imageUrl}
        alt="product-preview"
      />
    );

  return null;
};

ProductPreview.propTypes = {
  product: PropTypes.object,
  className: PropTypes.string
};

ProductPreview.defaultProps = {
  product: {},
  className: ""
};

export default ProductPreview;